import { defineMessages } from 'react-intl';

/**
 * The fixed AI notice of a post (EU AI Act Article 50, owner decisions of 2026-10-13). The text is
 * the same on the web and in the native apps; it has no switch.
 */
export const aiNoticeMessages = defineMessages({
  text: {
    id: 'app.sml.promote.aiNotice.text',
    defaultMessage: 'Contains AI-generated footage. MUSIC24 labels it on each platform that has an AI label.',
  },
  manual: {
    id: 'app.sml.promote.aiNotice.manual',
    defaultMessage: 'When you post by hand, turn on the AI label of the platform.',
  },
});
